'use strict';
/* ── HELPERS ── */
const $ = (s,c=document) => c.querySelector(s);
const $$ = (s,c=document) => [...c.querySelectorAll(s)];
const money = c => '€' + (c/100).toFixed(2).replace('.',',');

/* ── TOAST ── */
window.toast = msg => {
  let t = $('#re-toast');
  if(!t){ t=document.createElement('div'); t.id='re-toast'; t.className='toast'; t.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:16px;height:16px;stroke:var(--mint)"><polyline points="20 6 9 17 4 12"/></svg><span></span>'; document.body.appendChild(t); }
  t.querySelector('span').textContent = msg;
  t.classList.add('show');
  clearTimeout(t._t);
  t._t = setTimeout(() => t.classList.remove('show'), 3000);
};

/* ── HEADER SCROLL ── */
window.addEventListener('scroll', () => {
  $('.site-header')?.classList.toggle('scrolled', scrollY > 30);
}, {passive:true});

/* ── OVERLAYS ── */
const showOverlay = id => {
  const o = $('#'+id); if(!o) return;
  o.style.display='block';
  requestAnimationFrame(() => o.classList.add('open'));
  document.body.style.overflow='hidden';
};
const hideOverlay = id => {
  const o = $('#'+id); if(!o) return;
  o.classList.remove('open');
  setTimeout(() => { o.style.display='none'; }, 380);
  document.body.style.overflow='';
};

/* ── NAV DRAWER ── */
window.openNav  = () => { showOverlay('nav-ol'); $('#nav-drawer')?.classList.add('open'); };
window.closeNav = () => { hideOverlay('nav-ol'); $('#nav-drawer')?.classList.remove('open'); };

/* ── CART DRAWER ── */
window.openCart  = () => { showOverlay('cart-ol'); $('#cart-drawer')?.classList.add('open'); };
window.closeCart = () => { hideOverlay('cart-ol'); $('#cart-drawer')?.classList.remove('open'); };

/* ── CART API ── */
window.refreshCart = () => fetch('/cart.js').then(r=>r.json()).then(renderCart).catch(console.error);

const renderCart = cart => {
  // Update counts
  $$('[data-cart-count]').forEach(el => {
    el.textContent = cart.item_count > 0 ? cart.item_count : '';
    if(el.classList.contains('cart-bubble')) el.classList.toggle('show', cart.item_count > 0);
    if(el.classList.contains('tab-badge')) el.style.display = cart.item_count > 0 ? 'flex' : 'none';
  });
  const tot = $('#cd-total'); if(tot) tot.textContent = money(cart.total_price);
  const body = $('#cd-body'); if(!body) return;
  const ft = $('#cd-ft');
  if(!cart.items.length){
    body.innerHTML = `<div class="cd-empty"><div class="cd-empty-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg></div><h3 style="font-family:var(--serif);font-size:19px;color:var(--dark)">Winkelwagen is leeg</h3><p style="font-size:15px;color:var(--soft)">Bekijk onze regentonnen</p><a href="/collections/regentonnen" class="btn btn-primary btn-sm" style="margin-top:8px" onclick="closeCart()">Bekijk producten</a></div>`;
    if(ft) ft.style.display='none';
    return;
  }
  if(ft) ft.style.display='';
  body.innerHTML = cart.items.map(i => `
    <div class="cd-item">
      <div class="cd-item-img">${i.image ? `<img src="${i.image.replace(/(\.\w+)$/,'_160x160$1')}" alt="" loading="lazy">` : ''}</div>
      <div style="flex:1;min-width:0">
        <div class="cd-item-name">${i.product_title}</div>
        ${i.variant_title&&i.variant_title!=='Default Title'?`<div class="cd-item-var">${i.variant_title}</div>`:''}
        <div class="cd-item-row">
          <div class="cd-qty">
            <button class="cd-qty-btn" onclick="updateCart('${i.key}',${i.quantity-1})">−</button>
            <div class="cd-qty-num">${i.quantity}</div>
            <button class="cd-qty-btn" onclick="updateCart('${i.key}',${i.quantity+1})">+</button>
          </div>
          <div class="cd-item-price">${money(i.final_line_price)}</div>
        </div>
        <button class="cd-item-rm" onclick="updateCart('${i.key}',0)">Verwijderen</button>
      </div>
    </div>`).join('');
};

window.addToCart = (vid, qty, btn) => {
  if(!vid || vid==0) return;
  const orig = btn?.innerHTML || '';
  if(btn){ btn.disabled=true; btn.textContent='Toevoegen...'; }
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(vid),quantity:qty||1})})
    .then(() => { refreshCart(); openCart(); toast('Product toegevoegd!'); if(btn){ btn.classList.add('done'); btn.innerHTML='✓ Toegevoegd'; setTimeout(()=>{btn.disabled=false;btn.classList.remove('done');btn.innerHTML=orig;},2400); } })
    .catch(e => { console.error(e); if(btn){btn.disabled=false;btn.innerHTML=orig;} });
};

window.updateCart = (key, qty) => {
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,qty)})})
    .then(r=>r.json()).then(renderCart).catch(console.error);
};

/* ── PDP ── */
window.pdpQty = d => {
  const el = $('#pdp-qty-val'); if(!el) return;
  const cur = parseInt(el.textContent) || 1;
  el.textContent = Math.max(1, cur + d);
};

// Parse variants once
let _variants = null;
const getVariants = () => {
  if(_variants) return _variants;
  const json = $('#variants-json');
  if(!json) return [];
  try { _variants = JSON.parse(json.textContent); } catch(e){ _variants = []; }
  return _variants;
};

window.selectSize = btn => {
  if(!btn || btn.disabled) return;
  // Update swatch UI
  $$('.size-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');

  const vid = parseInt(btn.dataset.vid);
  if(!vid) return;

  // Update hidden input
  const input = $('#variant-id');
  if(input) input.value = vid;

  // Update label
  const lbl = $('#size-lbl');
  if(lbl) lbl.textContent = (btn.dataset.label || btn.textContent).trim();

  // Find variant data
  const v = getVariants().find(x => x.id === vid);
  if(!v) return;

  // Update price
  const pe = $('#pdp-price');
  if(pe) pe.textContent = money(v.price);
  const sp = $('#sticky-price');
  if(sp) sp.textContent = money(v.price);

  // Update compare_at_price / sale badge
  const oldEl = $('.pdp-price-old');
  const saveEl = $('.pdp-price-save');
  if(v.compare_at_price && v.compare_at_price > v.price){
    if(oldEl){ oldEl.textContent = money(v.compare_at_price); oldEl.style.display = ''; }
    if(saveEl){ saveEl.textContent = 'Bespaar ' + money(v.compare_at_price - v.price); saveEl.style.display = ''; }
  } else {
    if(oldEl) oldEl.style.display = 'none';
    if(saveEl) saveEl.style.display = 'none';
  }

  // Update ATC button
  const atc = $('#atc-btn');
  if(atc){
    atc.disabled = !v.available;
    if(v.available){
      atc.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:18px;height:18px"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>In winkelwagen';
    } else {
      atc.textContent = 'Uitverkocht';
    }
  }

  // Switch gallery to variant image
  const mediaId = btn.dataset.media;
  if(mediaId && mediaId !== ''){
    const slidesContainer = $('#pdp-slides');
    if(slidesContainer){
      const slides = [...slidesContainer.querySelectorAll('[data-media-id]')];
      const idx = slides.findIndex(s => s.dataset.mediaId === String(mediaId));
      if(idx >= 0) sliderGo(idx);
    }
  }

  // Update URL without reload
  try {
    const url = new URL(window.location);
    url.searchParams.set('variant', vid);
    history.replaceState(null, '', url);
  } catch(e){}
};

// On page load: select variant from URL param
const initVariantFromURL = () => {
  const params = new URLSearchParams(window.location.search);
  const vid = params.get('variant');
  if(!vid) return;
  const btn = $(`.size-btn[data-vid="${vid}"]`);
  if(btn && !btn.classList.contains('active')) {
    selectSize(btn);
  }
};

window.buyNow = () => {
  const vid = parseInt($('#variant-id')?.value);
  const qty = parseInt($('#pdp-qty-val')?.textContent)||1;
  if(!vid) return;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:qty})})
    .then(() => { window.location.href='/checkout'; }).catch(console.error);
};

/* ── SLIDER ── */
let sliderIdx = 0;
let sliderLocked = false;
window.sliderGo = n => {
  if(sliderLocked) return;
  const slides = $('#pdp-slides'); if(!slides) return;
  const count = slides.children.length;
  sliderIdx = ((n % count) + count) % count;
  slides.style.transform = `translateX(-${sliderIdx * 100}%)`;
  $$('.pdp-dot').forEach((d,i) => d.classList.toggle('active', i === sliderIdx));
  $$('.pdp-thumb').forEach((t,i) => t.classList.toggle('active', i === sliderIdx));
  // Lock briefly to prevent rapid fire
  sliderLocked = true;
  setTimeout(() => { sliderLocked = false; }, 380);
};
window.sliderNext = () => sliderGo(sliderIdx + 1);
window.sliderPrev = () => sliderGo(sliderIdx - 1);
// Touch swipe - only on the slider itself, never auto-fires
(()=>{
  let sx = 0, sy = 0, swiping = false;
  document.addEventListener('touchstart', e => {
    const sl = e.target.closest('#pdp-slider');
    if (!sl) return;
    sx = e.touches[0].clientX;
    sy = e.touches[0].clientY;
    swiping = true;
  }, {passive: true});
  document.addEventListener('touchend', e => {
    if (!swiping) return;
    swiping = false;
    const dx = sx - e.changedTouches[0].clientX;
    const dy = sy - e.changedTouches[0].clientY;
    // Only trigger if horizontal swipe is dominant (not vertical scroll)
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      dx > 0 ? sliderNext() : sliderPrev();
    }
  }, {passive: true});
})();

/* ── STICKY ATC ── */
const initStickyATC = () => {
  const bar=$('.sticky-atc'), trigger=$('.pdp-atc');
  if(!bar||!trigger) return;
  const check = () => bar.classList.toggle('show', trigger.getBoundingClientRect().bottom < 0);
  window.addEventListener('scroll', check, {passive:true});
  check();
};

/* ── TABS ── */
const initTabs = () => $$('.tab-btn').forEach(btn => btn.addEventListener('click', () => {
  const c=btn.closest('.pdp-tabs'); if(!c) return;
  $$('.tab-btn',c).forEach(b=>b.classList.remove('active'));
  $$('.tab-panel',c).forEach(p=>p.classList.remove('active'));
  btn.classList.add('active');
  c.querySelector(`[data-panel="${btn.dataset.tab}"]`)?.classList.add('active');
}));

/* ── ACCORDION ── */
const initAccordions = () => $$('.faq-q').forEach(btn => btn.addEventListener('click', () => {
  const item=btn.closest('.faq-item'), ans=item?.querySelector('.faq-ans'); if(!item||!ans) return;
  const open=item.classList.contains('open');
  $$('.faq-item.open').forEach(i=>{i.classList.remove('open');const a=i.querySelector('.faq-ans');if(a)a.style.maxHeight='0';});
  if(!open){item.classList.add('open');ans.style.maxHeight=ans.scrollHeight+'px';}
}));

/* ── PRODUCT FORM ── */
const initProductForm = () => {
  const form=$('#product-form'); if(!form) return;
  form.addEventListener('submit', e => {
    e.preventDefault();
    const vid=parseInt($('#variant-id').value);
    const qty=parseInt($('#pdp-qty-val')?.textContent)||1;
    if(vid) addToCart(vid, qty, $('#atc-btn'));
  });
};

/* ── COUNTDOWN ── */
const initCountdown = () => {
  const els=$$('[data-timer]'); if(!els.length) return;
  const msgEl=$('.pdp-timer-msg');
  const tick = () => {
    const now=new Date();
    const day=now.getDay(); // 0=sun,6=sat
    const hour=now.getHours();
    // Weekend: show "Bestel nu, maandag verzonden"
    if(day===0||day===6||(day===5&&hour>=15)){
      els.forEach(el=>el.textContent='');
      if(msgEl) msgEl.innerHTML='Bestel dit weekend, <strong>maandag verzonden</strong>';
      const container=$('.pdp-timer');
      if(container) container.classList.add('pdp-timer--weekend');
      return;
    }
    // Weekday after 15:00: next business day
    const cut=new Date();
    cut.setHours(15,0,0,0);
    if(now>=cut){
      els.forEach(el=>el.textContent='');
      if(msgEl) msgEl.innerHTML='Bestel nu, <strong>morgen verzonden</strong>';
      return;
    }
    const d=cut-now, h=Math.floor(d/3600000), m=Math.floor((d%3600000)/60000), s=Math.floor((d%60000)/1000);
    const str=`${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
    els.forEach(el=>el.textContent=str);
    if(msgEl) msgEl.innerHTML='Bestel binnen <strong data-timer class="pdp-timer-val">'+str+'</strong> voor verzending vandaag';
  };
  tick(); setInterval(tick,1000);
};

/* ── REVEAL ── */
const initReveal = () => {
  const els=$$('.reveal'); if(!els.length) return;
  if(!('IntersectionObserver' in window)){els.forEach(e=>e.classList.add('visible'));return;}
  const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');io.unobserve(e.target);}}),{threshold:.06,rootMargin:'0px 0px -20px 0px'});
  els.forEach(el=>{if(el.getBoundingClientRect().top<innerHeight){el.classList.add('visible');}else{io.observe(el);}});
};

/* ── CALCULATOR ── */
const initCalc = () => {
  const btn=$('#calc-btn'); if(!btn) return;
  btn.addEventListener('click', () => {
    const opp=parseFloat($('#calc-opp')?.value)||0;
    const neerslag=parseFloat($('#calc-neerslag')?.value)||800;
    const coeff=parseFloat($('#calc-type')?.value)||0.85;
    if(!opp||opp<=0){toast('Vul een geldig dakoppervlak in');return;}
    const j=Math.round(opp*(neerslag/1000)*coeff*1000);
    // Total value: €4.20/m³ (water €1.50 + rioolheffing €0.80 + tuinslang/sproei €0.90 + droogtebestendigheid €1.00)
    const b=Math.round(j*0.0042*10)/10;
    const p=j>8000?119.95:j>5000?89.95:j>3000?69.95:j>1500?59.95:49.95;
    const tvJaar = b > 0 ? p/b : 0;
    const tv = tvJaar > 0 ? (tvJaar < 1 ? Math.round(tvJaar*12)+' maanden' : tvJaar < 2 ? '1 jaar' : tvJaar.toFixed(1)+' jaar') : '—';
    const res=$('#calc-res'); if(res) res.classList.add('show');
    const el=n=>$('#calc-'+n);
    if(el('liter')) el('liter').textContent=Math.round(j).toLocaleString('nl-NL')+' L';
    if(el('besparing')) el('besparing').textContent='€'+b.toFixed(2).replace('.',',');
    if(el('tv')) el('tv').textContent=tv;
  });
};

/* ── KEUZEHULP ── */
let khStep=0, khAns={}, khMulti={};
const KH=[
  {
    q:'Hoe groot is uw tuin of balkon?',
    sub:'Dit bepaalt hoeveel water u kunt gebruiken.',
    opts:[
      {l:'Balkon of klein terras',d:'Minder dan 15 m² buitenruimte',v:'balkon',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="8" width="16" height="13" rx="2"/><path d="M4 10l8-8 8 8"/><rect x="9" y="13" width="6" height="8"/></svg>'},
      {l:'Kleine tuin',d:'15–50 m², borders en potten',v:'klein',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 22V10"/><path d="M5 3s0 6 7 7c7-1 7-7 7-7"/><path d="M5 13s0 4 7 5c7-1 7-5 7-5"/></svg>'},
      {l:'Middelgrote tuin',d:'50–100 m², inclusief gazon',v:'middel',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M2 9l10-7 10 7"/></svg>'},
      {l:'Grote tuin of moestuin',d:'Meer dan 100 m², intensief gebruik',v:'groot',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="1" y="6" width="22" height="15" rx="2"/><path d="M1 8l11-6 11 6"/><rect x="8" y="14" width="4" height="7"/><rect x="12" y="14" width="4" height="7"/></svg>'}
    ]
  },
  {
    q:'Waarvoor wilt u het regenwater gebruiken?',
    sub:'Meerdere antwoorden zijn mogelijk — kies uw hoofdgebruik.',
    opts:[
      {l:'Planten besproeien',d:'Bloemen, sierplanten, borders',v:'planten',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 22V11"/><path d="M12 11C12 7 8 4 4 5c0 5 3 8 8 6"/><path d="M12 11c0-4 4-7 8-6-1 5-4 8-8 6"/></svg>'},
      {l:'Moestuin',d:'Groenten, kruiden en fruit',v:'moes',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="14" width="20" height="7" rx="1"/><path d="M7 14V9m5 5V7m5 7V10"/></svg>'},
      {l:'Gazon of gras',d:'Grasveld en gazon sproeien',v:'gazon',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M2 20h20M4 20V10m4 10V7m4 10V4m4 10V7m4 10V10"/></svg>'},
      {l:'Schoonmaken of auto',d:'Tuin, terras en auto reinigen',v:'schoon',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M19 17H5a2 2 0 01-2-2V9a2 2 0 012-2h14a2 2 0 012 2v6a2 2 0 01-2 2z"/><circle cx="7.5" cy="17" r="2.5"/><circle cx="16.5" cy="17" r="2.5"/></svg>'}
    ]
  },
  {
    q:'Welk design spreekt u het meest aan?',
    sub:'Onze regentonnen zijn verkrijgbaar in verschillende stijlen.',
    opts:[
      {l:'Klassiek & functioneel',d:'Sober design, past overal bij',v:'klassiek',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="6" y="4" width="12" height="18" rx="3"/><line x1="9" y1="9" x2="15" y2="9"/><line x1="9" y1="13" x2="15" y2="13"/></svg>'},
      {l:'Modern & strak',d:'Minimalistische look voor de moderne tuin',v:'modern',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="3" width="16" height="20" rx="2"/><line x1="4" y1="8" x2="20" y2="8"/></svg>'},
      {l:'Decoratief',d:'Sierlijk model dat ook als eyecatcher werkt',v:'deco',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 2C6 2 3 9 3 14a9 9 0 0018 0C21 9 18 2 12 2z"/><path d="M8 12c0-2.2 1.8-4 4-4"/></svg>'},
      {l:'Geen voorkeur',d:'Beste prijs-kwaliteit verhouding',v:'neutraal',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><polyline points="20 6 9 17 4 12"/></svg>'}
    ]
  },
  {
    q:'Welke kleur heeft uw voorkeur?',
    sub:'Kies een kleur die past bij uw tuin of gevel.',
    opts:[
      {l:'Antraciet / Grafiet',d:'Donkere moderne kleur — meest gekozen',v:'antraciet',icon:'<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="3" fill="#2d3748"/></svg>'},
      {l:'Terra / Bruin',d:'Warme aardse tint, past bij hout en steen',v:'terra',icon:'<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="3" fill="#8B4513"/></svg>'},
      {l:'Groen',d:'Valt op in de natuur, mooi in borders',v:'groen',icon:'<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="3" fill="#2d6a4f"/></svg>'},
      {l:'Maakt mij niet uit',d:'Beste aanbod ongeacht kleur',v:'nvt',icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><polyline points="20 6 9 17 4 12"/></svg>'}
    ]
  }
];

const khAdvice = ans => {
  const tuin = ans[0];
  let sizeLabel = 'grote regenton', url = '/collections/regentonnen', isExternal = false, note = '';
  if(tuin==='balkon') {
    sizeLabel = 'opvouwbare regenton'; isExternal = true;
    url = 'https://waterdeal.nl/collections/opvouwbare-regentonnen';
    note = 'Voor een balkon of terras is een opvouwbare regenton ideaal — compact en makkelijk op te bergen in de winter.';
  } else if(tuin==='klein') {
    sizeLabel = 'kleine regenton';
    note = 'Voor een kleine tuin is een kleine regenton perfect. Voldoende capaciteit voor planten en borders.';
  } else {
    sizeLabel = 'grote regenton';
    note = 'Voor een middelgrote of grote tuin raden wij een grote regenton aan. Maximale opvang voor moestuin en gazon.';
  }
  return {sizeLabel, url, isExternal, note, kleurTip: ''};
};

const khRender = () => {
  const body=$('#kh-body'), fill=$('#kh-fill'); if(!body) return;
  fill && (fill.style.width=Math.round(khStep/KH.length*100)+'%');

  if(khStep>=KH.length){
    fill && (fill.style.width='100%');
    const r=khAdvice(khAns);
    body.innerHTML=`
      <div style="padding:8px 0">
        <div style="display:flex;align-items:center;gap:12px;margin-bottom:18px">
          <div style="width:52px;height:52px;background:var(--mint-pale);border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0">
            <svg viewBox="0 0 24 24" style="width:26px;height:26px" fill="none" stroke="var(--forest2)" stroke-width="1.8"><path d="M12 2C12 2 4 10 4 15a8 8 0 0016 0C20 10 12 2 12 2Z"/></svg>
          </div>
          <div>
            <div style="font-family:var(--serif);font-size:22px;font-weight:600;color:var(--dark)">Uw perfecte keuze</div>
            <div style="font-size:14px;color:var(--soft)">Gebaseerd op uw tuin en voorkeuren</div>
          </div>
        </div>
        <div style="background:var(--cream2);border:1.5px solid var(--border);border-radius:var(--r-xl);padding:18px 22px;margin-bottom:14px">
          <div style="font-size:11px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:var(--sage);margin-bottom:6px">Ons advies</div>
          <div style="font-family:var(--serif);font-size:20px;font-weight:600;color:var(--dark);margin-bottom:6px">${r.sizeLabel}</div>
          <div style="font-size:14px;color:var(--mid);line-height:1.65">${r.note}${r.kleurTip?' '+r.kleurTip:''}</div>
        </div>
        <div style="display:flex;flex-direction:column;gap:7px;margin-bottom:20px">
          <div style="display:flex;align-items:center;gap:8px;font-size:14px;color:var(--mid)">
            <svg viewBox="0 0 24 24" style="width:14px;height:14px;flex-shrink:0" fill="none" stroke="var(--sage)" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
            Gratis koppelset inbegrepen
          </div>
          <div style="display:flex;align-items:center;gap:8px;font-size:14px;color:var(--mid)">
            <svg viewBox="0 0 24 24" style="width:14px;height:14px;flex-shrink:0" fill="none" stroke="var(--sage)" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
            Gratis verzending &amp; 30 dagen retour
          </div>
        </div>
        <a href="${r.url}" class="btn btn-primary btn-full btn-lg" style="margin-bottom:12px;justify-content:center">${r.isExternal?'Bekijk Waterdeal.nl →':'Bekijk '+r.sizeLabel+'s →'}</a>
        <div style="text-align:center"><span style="font-size:13px;color:var(--soft);cursor:pointer;text-decoration:underline" onclick="khRestart()">↺ Opnieuw beginnen</span></div>
      </div>`;
    return;
  }

  const s=KH[khStep];
  body.innerHTML=`
    <div style="margin-bottom:6px;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--electric)">Vraag ${khStep+1} van ${KH.length}</div>
    <div class="kh-q">${s.q}</div>
    ${s.sub?`<div style="font-size:14px;color:var(--soft);margin:-8px 0 16px">${s.sub}</div>`:''}
    ${khStep===1?'<div style="font-size:12px;color:var(--electric);font-weight:700;margin-bottom:14px;display:flex;align-items:center;gap:6px"><svg viewBox=\"0 0 24 24\" style=\"width:13px;height:13px\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\"><polyline points=\"9 11 12 14 22 4\"/><path d=\"M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11\"/></svg>Meerdere antwoorden mogelijk</div>':''}
    <div class="kh-opts">${s.opts.map(o=>{
      const sel=(khMulti[1]||[]).indexOf(o.v)>-1;
      const isMulti=khStep===1;
      return `<button class="kh-opt${sel?' kh-opt--sel':''}" onclick="khPick(this,'${o.v}')">
        <div class="kh-opt-ic">${o.icon}</div>
        <div style="text-align:left;flex:1"><h4>${o.l}</h4><p>${o.d}</p></div>
        ${isMulti?`<div style="width:22px;height:22px;border-radius:6px;border:2px solid ${sel?'var(--electric)':'var(--border)'};background:${sel?'var(--electric)':'transparent'};display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all .15s">${sel?'<svg viewBox=\"0 0 24 24\" style=\"width:12px;height:12px\" fill=\"none\" stroke=\"#fff\" stroke-width=\"3\"><polyline points=\"20 6 9 17 4 12\"/></svg>':''}</div>`:''}
      </button>`;
    }).join('')}
    </div>
    ${khStep===1?`<button onclick="if(!(khMulti[1]||[]).length)return;khStep++;khRender();" style="width:100%;height:50px;margin-top:12px;background:${(khMulti[1]||[]).length?'linear-gradient(135deg,#2563eb,#0ea5e9)':'#e5e7eb'};color:${(khMulti[1]||[]).length?'#fff':'#9ca3af'};border:none;border-radius:var(--r-full);font-size:15px;font-weight:700;cursor:pointer;font-family:var(--sans);transition:all .2s">Volgende stap →</button>`:''}
    <div class="kh-nav" style="margin-top:${khStep===1?'10px':'0'}">
      ${khStep>0?`<span class="kh-back" onclick="khBack()">← Terug</span>`:'<span></span>'}
      <div class="kh-dots">${KH.map((_,i)=>`<div class="kh-dot${i<khStep?' done':i===khStep?' cur':''}"></div>`).join('')}</div>
      <span style="font-size:12px;color:var(--muted)">${khStep+1}/${KH.length}</span>
    </div>`;
};
window.khPick=(el,val)=>{
  // Step 1 (gebruik/waarvoor) supports multi-select
  if(khStep===1){
    if(!khMulti[1]) khMulti[1]=[];
    const idx=khMulti[1].indexOf(val);
    if(idx>-1){ khMulti[1].splice(idx,1); el.classList.remove('kh-opt--sel'); }
    else { khMulti[1].push(val); el.classList.add('kh-opt--sel'); }
    // Update khAns with all selected values
    khAns[1]=khMulti[1].join(',');
    return; // Don't advance yet - user clicks "Volgende" button
  }
  khAns[khStep]=val;khStep++;khRender();
};
window.khBack=()=>{khStep=Math.max(0,khStep-1);if(khStep===1&&khMulti[1]){}khRender();};
window.khRestart=()=>{khStep=0;khAns={};khMulti={};khRender();};
const initKh=()=>{if($('#kh-body'))khRender();};

/* ── KEYBOARD ── */
document.addEventListener('keydown', e => { if(e.key==='Escape'){closeNav();closeCart();} });

/* ── INIT ── */
document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  initProductForm();
  initTabs();
  initAccordions();
  initStickyATC();
  initCalc();
  initKh();
  initCountdown();
  initSearch();
  initReviewCarousel();
  initVariantFromURL();
  refreshCart();
});

/* ── REVIEW CAROUSEL ── */
const initReviewCarousel = () => {
  const track = $('.reviews-carousel-track');
  if (!track) return;
  const cards = $$('.review-carousel-card', track);
  if (cards.length < 2) return;
  let idx = 0;
  const show = (n) => {
    idx = ((n % cards.length) + cards.length) % cards.length;
    track.style.transform = `translateX(-${idx * 100}%)`;
    $$('.rc-dot').forEach((d,i) => d.classList.toggle('active', i === idx));
  };
  window.rcNext = () => show(idx + 1);
  window.rcPrev = () => show(idx - 1);
  window.rcGoTo = (n) => show(n);
  let autoplay = setInterval(() => show(idx + 1), 5000);
  const container = track.closest('.reviews-carousel');
  if (container) {
    container.addEventListener('mouseenter', () => clearInterval(autoplay));
    container.addEventListener('mouseleave', () => { autoplay = setInterval(() => show(idx + 1), 5000); });
  }
  // Touch swipe
  let sx=0;
  track.addEventListener('touchstart',e=>{sx=e.touches[0].clientX;},{passive:true});
  track.addEventListener('touchend',e=>{const dx=sx-e.changedTouches[0].clientX;if(Math.abs(dx)>40){dx>0?show(idx+1):show(idx-1);}},{passive:true});
};

/* ── SEARCH ── */
window.toggleSearch = () => {
  const dd = $('#search-dropdown');
  if (!dd) return;
  const open = dd.classList.contains('open');
  if (open) {
    dd.classList.remove('open');
    document.removeEventListener('click', closeSearchOutside);
  } else {
    dd.classList.add('open');
    setTimeout(() => {
      $('#search-input')?.focus();
      document.addEventListener('click', closeSearchOutside);
    }, 50);
  }
};

function closeSearchOutside(e) {
  const dd = $('#search-dropdown');
  const toggle = $('.hdr-search-toggle');
  if (dd && !dd.contains(e.target) && toggle && !toggle.contains(e.target)) {
    dd.classList.remove('open');
    document.removeEventListener('click', closeSearchOutside);
  }
}

let searchDebounce;
const initSearch = () => {
  const input = $('#search-input');
  if (!input) return;
  input.addEventListener('input', () => {
    clearTimeout(searchDebounce);
    const q = input.value.trim();
    if (q.length < 2) { $('#search-results').innerHTML = ''; return; }
    searchDebounce = setTimeout(() => doSearch(q), 250);
  });
  input.addEventListener('keydown', e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const q = input.value.trim();
      if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
    }
    if (e.key === 'Escape') toggleSearch();
  });
};

const doSearch = q => {
  fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
    .then(r => r.json())
    .then(data => {
      const res = $('#search-results');
      if (!res) return;
      const products = data.resources?.results?.products || [];
      if (!products.length) {
        res.innerHTML = '<div class="search-no-results">Geen resultaten voor "' + q.replace(/</g,'&lt;') + '"</div>';
        return;
      }
      res.innerHTML = products.map(p => {
        const img = p.image ? p.image.replace(/(\.\w+)(\?|$)/, '_160x160$1$2') : '';
        const price = '€' + (p.price / 100 || parseFloat(p.price) || 0).toFixed(2).replace('.', ',');
        return `<a href="${p.url}" class="search-result-item">
          ${img ? `<img src="${img}" alt="" width="48" height="48" loading="lazy">` : ''}
          <div><div class="search-result-title">${p.title}</div><div class="search-result-price">${price}</div></div>
        </a>`;
      }).join('') + `<a href="/search?q=${encodeURIComponent(q)}" class="search-view-all">Alle resultaten bekijken →</a>`;
    })
    .catch(() => {});
};

/* Product page FAQ */
window.pdpFaqToggle = (btn) => {
  const item = btn.parentElement;
  const ans = item.querySelector('.pdp-faq-a');
  const isOpen = btn.classList.contains('open');
  // Close all
  document.querySelectorAll('.pdp-faq-q.open').forEach(b => {
    b.classList.remove('open');
    b.parentElement.querySelector('.pdp-faq-a').classList.remove('open');
  });
  if (!isOpen) {
    btn.classList.add('open');
    ans.classList.add('open');
  }
};

/* ── 360 VIEWER ── */
window.init360Viewer = () => {
  const container = $('.pdp-360-viewer');
  if (!container) return;
  const images = $$('img', container);
  if (images.length < 2) return;

  let currentFrame = 0;
  let isDragging = false;
  let startX = 0;
  const totalFrames = images.length;

  const showFrame = (index) => {
    images.forEach((img, i) => img.style.display = i === index ? 'block' : 'none');
  };

  container.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.clientX;
    container.style.cursor = 'grabbing';
  });

  window.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 10) {
      const frameOffset = Math.floor(dx / 10);
      currentFrame = (currentFrame - frameOffset + totalFrames) % totalFrames;
      showFrame(currentFrame);
      startX = e.clientX;
    }
  });

  window.addEventListener('mouseup', () => {
    isDragging = false;
    container.style.cursor = 'grab';
  });

  // Touch support
  container.addEventListener('touchstart', (e) => {
    isDragging = true;
    startX = e.touches[0].clientX;
  }, {passive: true});

  container.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    const dx = e.touches[0].clientX - startX;
    if (Math.abs(dx) > 10) {
      const frameOffset = Math.floor(dx / 10);
      currentFrame = (currentFrame - frameOffset + totalFrames) % totalFrames;
      showFrame(currentFrame);
      startX = e.touches[0].clientX;
    }
  }, {passive: true});

  container.addEventListener('touchend', () => {
    isDragging = false;
  });

  // Initial state
  showFrame(0);
};




